export enum FeatureNames {
  OnlinePayment = 'ONLINE_PAYMENT',
  DirectDebit = 'DIRECT_DEBIT',
  ChangeBankDetails = 'CHANGE_BANK_DETAILS',
  ChangePaymentSchedule = 'CHANGE_PAYMENT_SCHEDULE',
  PSRRenewal = 'PSR_RENEWAL',
  HomeMove = 'HOME_MOVES',
  RegisterForOnlineAccount = 'REGISTER_FOR_ONLINE_ACCOUNT',
  RegisterForOnlineAccountV2 = 'REGISTER_FOR_ONLINE_ACCOUNT_V2',
  ForgottenEmail = 'FORGOTTEN_EMAIL',
  CreateNewAccount = 'CREATE_NEW_ACCOUNT',
  AdobeAnalytics = 'ADOBE_ANALYTICS',
  GoogleAnalytics = 'GOOGLE_ANALYTICS',
  RequestPrintedBill = 'REQUEST_PRINTED_BILL',
  NectarPhaseOne = 'NECTAR_PHASE_ONE',
  ApplyForMeter = 'APPLY_FOR_METER',
  SwitchToMeasured = 'SWITCH_TO_MEASURED',
  MoversDetails = 'MOVERS_DETAILS',
  NewEditDirectDebitUnmeasuredUI = 'NEW_EDIT_DD_UNMEASURED_UI',
  ChargeDetails = 'CHARGE_DETAILS',
  Portfolio = 'PORTFOLIO',
  PayInFull = 'PAY_IN_FULL',
  ReciteMe = 'RECITE_ME',
  NextInstalment = 'NEXT_INSTALMENT',
  GuestApplyForMeter = 'GUEST_APPLY_FOR_METER',
  SetupDDPropertyDetails = 'SETUP_DD_PROPERTY_DETAILS',
  CancelDirectDebit = 'CANCEL_DIRECT_DEBIT',
  GuestApplyForMeterV2 = 'GUEST_APPLY_FOR_METER_V2',
  GuestApplyForMeterV3 = 'GUEST_APPLY_FOR_METER_V3',
  BillTracker = 'BILL_TRACKER',
  SmartMeterChart = 'SMART_METER_CHART',
  NectarConnect = 'NECTAR_CONNECT',
}
